import styled from 'styled-components';
import { TemplateType } from 'constants/templateTypes';
import { InfoBanner } from 'ui/banner';
import { spacing } from 'ui/theme';
import { WhatsAppMedium } from 'constants/messageMediums';
import { useEditableFieldsContext } from 'modules/templateEditor/context/EditableFieldsContext';

const StyledInfoBanner = styled(InfoBanner)`
  margin-bottom: ${spacing.half};
`;

export const TemplatePreviewBanner = () => {
  const { selectedMessageMedium, liveTemplate } = useEditableFieldsContext();

  if (
    selectedMessageMedium !== WhatsAppMedium.WhatsApp ||
    liveTemplate?.templateType !== TemplateType.UserInitiated
  ) {
    return null;
  }

  return (
    <StyledInfoBanner>
      User-initiated templates will only be sent if a recipient has contacted your business within
      the last 24 hours.
    </StyledInfoBanner>
  );
};
